'use client';

import { SummaryCTAWrapper } from '@/components';
import { useSalePageQuery } from '@/entities/salePage';
import { Element, Skeleton } from '@vuddy/components';
import { isNil } from 'lodash-es';
import { EndedCTA, PlannedCTA } from '../cta';
import SummaryOnSaleCTA from '../cta/SummaryOnSaleCTA';
import * as styles from './summary.css';

interface SummaryCTAProps {
  salePageId: number;
}

const SummaryCTA = ({ salePageId }: SummaryCTAProps) => {
  const { data: salePage, isLoading: isSalePageLoading } =
    useSalePageQuery(salePageId);

  if (!salePage) return null;

  return (
    <Element className={styles.summaryCTA}>
      <SummaryCTAWrapper direction="vertical">
        {isNil(salePage?.saleStatus) || isSalePageLoading ? (
          <Skeleton height="52px" />
        ) : salePage.saleStatus === 'PLANNED' ? (
          isNil(salePage.saleTimeRange?.startAt) ? null : (
            <PlannedCTA openDate={salePage.saleTimeRange.startAt} />
          )
        ) : salePage?.saleStatus === 'ON_SALE' ? (
          <SummaryOnSaleCTA salePageId={salePageId} />
        ) : (
          <EndedCTA status={salePage?.saleStatus} />
        )}
      </SummaryCTAWrapper>
    </Element>
  );
};

export default SummaryCTA;
